import { Language } from '../constants/languages';
export const PAGINATION_MARGIN_TOP = [16, 24];
export const CAROUSEL_TRANSLATIONS_KEYS = {
  accessibleLabelNextSlideButton: 'component.Carousel.nextSlideButton',
  accessibleLabelPrevSlideButton: 'component.Carousel.prevSlideButton'
};
export const CAROUSEL_TRANSLATIONS = {
  [Language.EN]: {
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelNextSlideButton]: 'Next slide',
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelPrevSlideButton]: 'Prev slide'
  },
  [Language.PL]: {
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelNextSlideButton]: 'Następny slajd',
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelPrevSlideButton]: 'Poprzedni slajd'
  },
  [Language.SK]: {
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelNextSlideButton]: 'Nasledujúci slajd',
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelPrevSlideButton]: 'Predchádzajúci slajd'
  },
  [Language.CS]: {
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelNextSlideButton]: 'Následující slajd',
    [CAROUSEL_TRANSLATIONS_KEYS.accessibleLabelPrevSlideButton]: 'Předchozí slajd'
  }
};